import { createStore } from 'vuex';
import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';
import initialstate from './state';
import admin from './admin';

export default createStore({
    state() {
        return {
            ...initialstate
        };
    },
    getters: getters,
    mutations: mutations,
    actions: actions,
    modules: {
        admin
    }
});
